export const DEFAULT_QUIZ = {
  id: 'relationship-assessment',
  title: 'Relationship Assessment',
  scoringConfig: {
    maxWeightPerQuestion: 250,
    thresholds: {
      partnership: 70,
      adHoc: 50
    }
  },
  typeDefinitions: [
    { 
        id: 'A', 
        label: 'Ad Hoc', 
        desc: `A project driven or situational relationship where [Name] typically calls you to help with an immediate requirement or problem.

If you are in sales, the relationship may result in good revenue but wins are situational (right price, right time); there is little certainty. As requests are often unexpected, they become urgent and you operate on [Name]'s time rather than your own.

[Name] typically asks you to prepare time-consuming proposals explaining how you can help, the price and associated terms.` 
    },
    { 
        id: 'T', 
        label: 'Technical', 
        desc: `[Name] recognizes your technical ability and that your offering is as good or better than your competitors, but there is little personal rapport.

Your interactions with [Name] are functional and centre on business issues or the requirements at the time.

A specific problem with this type of relationship is that if, at some point, a competitor is seen to be more knowledgeable or cost effective they will supplant you.` 
    },
    { 
        id: 'S', 
        label: 'Social', 
        desc: `You get on well with [Name]; the relationship is friendly but it could be potentially superficial. You probably share some common interests and enjoy each other's company.

However conversations are less likely to come to grips with business issues and when they do there can be some awkwardness as neither of you wants to risk compromising the perceived friendship.` 
    },
    { 
        id: 'P', 
        label: 'Partnership', 
        desc: `[Name] trusts you; [he] sees you as a trusted advisor and will often ask for your advice whether or not it is within your field of expertise as [he] simply values your opinion.

If you are a salesperson [Name] sees you as being there to help [him] rather than to sell to [him].
[Name] usually gains value out of every interaction; because [he] trusts you [he] can discuss issues with you that [he] cannot with most others. You are a confidante.

In sales situations there are no lengthy proposals and rarely an argument about price since [Name] believes you treat [him] fairly.` 
    }
  ],
  classificationRules: {
  // Inside DEFAULT_QUIZ.classificationRules:
scoreDetailBands: {
  P: [
    {
      scoreRange: "70-79",
      meetings: {
        "1": [
          "Congratulations! Seems like you had a good meeting with [name]; your interaction indicates that you are doing the things that build partner relationships. This was only your first  meeting, so there is more to do, but you are certainly on the right track."
        ],
        "2": [
          "Congratulations! Your interaction with [name] indicates you are on track to creating a partner relationship with [him].",
          "Stay focused on helping [name] achieve [his] personal and business goals, both short and long term and [he] will come to trust and depend upon you."
        ],
        "3": [
          "Congratulations! You have a partner relationship with [name] and are demonstrating the behaviors that show you are focused on [his] needs."
        ]
      }
    },
    {
      scoreRange: "80",
      meetings: {
        "1": [
          "Congratulations! It seems like you had a great meeting. Your interaction with [name] will quickly lead to a partner relationship. As this was just your first meeting, you won't be there yet, but keep doing what you are doing and partnership should be inevitable."
        ],
        "2": [
          "Congratulations! Your interaction with [name] indicates you are on track to creating a partner relationship with [him]. Your interaction is clearly focused on helping [name] achieve [his] personal and business goals, both short and long term."
        ],
        "3": [
          "Congratulations! Based on your interaction in this meeting, you appear to have a strong partner relationship with [name]. Your interaction is clearly focused on helping [him] achieve [his] personal and business goals, both short and long term."
        ]
      }
    }
  ],

  T: [
    {
      scoreRange: "60-69",
      meetings: {
        "1": [
          "Well done! It is early days, but based on this meeting with [name] the signs are that you are on track to building a partner relationship with [him]. There are probably a few small things you can do to get there and make the relationship less Technical.",
          "Focus a little more on [name]'s well-being, particularly longer term, You can do this by increasing the scope i.e. breadth of issues you discuss and by looking more to the future than the present. In particular you should do this in the context of [name] personally by including more personal conversations."
        ],
        "2": [
          "Well done! It is early days, but based on this meeting with [name] the signs are that you are on track to building a partner relationship with [him]. There are probably a few small things you can do to get there and make the relationship less Technical.",
          "Focus a little more on [name]'s well-being, particularly longer term, You can do this by increasing the scope i.e. breadth of issues you discuss and by looking more to the future than the present. In particular you should do this in the context of [name] personally by including more personal conversations."
        ],
        "3": [
          "Well done! Your interaction with [name] indicates you are on track to becoming a partner; there are probably a few small things you can do to get there and make the relationship less Technical.",
          "Focus a little more on [name]'s well-being, particularly longer term, You can do this by increasing  the scope i.e. breadth of issues you discuss and by looking more to the future than the present. In particular you should do this in the context of [name] personally by including more personal conversations."
        ]
      }
    },
    {
      scoreRange: "50-59",
      meetings: {
        "1": [
          "It is early days, but the interaction in this meeting indicates you could be developing a Technical relationship with [name]. That is often the case when a technical inquiry is  the prompt for an initial meeting. However, you do not want to get locked into that dynamic. You need to focus on the relationship (not just the inquiry) early.",
          "[Name] probably sees you as a valuable source of knowledge in your areas of expertise, but not so much in an overall sense. For example, [name] probably recognizes you provide a great product and/or service that compares well with other offerings.  However, your goal is for [name] to value you personally.",
          "You are vulnerable as you are not personally differentiated from other people that [name] interacts with. For example, competitors may be trying to build a better more broad relationship."
        ],
        "2": [
          "It is early days, but the interaction in this meeting indicates you could be developing a technical relationship with [name]. That is often the case when a technical inquiry was the prompt for the initial meetings. However, you need to be careful that you do not get locked into that dynamic. You need to focus on building the relationship (as well as responding to the inquiry) early.",
          "[Name] probably sees you as a valuable source of knowledge in your areas of expertise, but not so much in an overall sense. For example, [name] probably recognizes that you provide a great product and/or service that compares well with other offerings.  However, your goal is for [name] to value you personally.",
          "You are vulnerable as you are not personally differentiated from other people that [name] interacts with. For example, competitors may be trying to build a better more broad relationship."
        ],
        "3": [
          "The interaction in this meeting indicates that your relationship with [name] is clearly a Technical one.  [He] probably sees you as a valuable source of knowledge in areas of your expertise, but less so in a general sense.",
          "For example, [name] probably recognizes you provide a great product and/or service that compares well with other offerings.  However, you are vulnerable as you are not personally differentiated from other people that [name] interacts with. For example, competitors may be trying to build a better more broad relationship.",
          "Your focus must be to get on a much stronger personal footing with [name] so that [he] comes to trust you and care about you."
        ]
      }
    },
    {
      scoreRange: "50",
      meetings: {
        "1": [
          "The interaction in this meeting appears to have had a strong technical focus, which is not unusual for a first meeting if it was in response to a specific inquiry. However, the concern is that [name] sees your value to [him] as strongly dependent on your subject area expertise or the quality (say) of your product or service. You need to focus on building your relationship, not just addressing technical issues.",
          "You are in a vulnerable position as you are relevant to [name] for only as long as your knowledge or products are relevant. That is, you personally are not important to [him]. It means that [name] is unlikely to cut you much slack if you make mistakes; they just undermine your relevance."
        ],
        "2": [
          "The interaction in this meeting indicates that your relationship with [name] is a Technical one where the value you bring is strongly dependent on your subject area expertise or the quality (say) of your product or service. You need to focus more on building a relationship with [name] by getting on to a more personal rather than technical footing.",
          "You are in a vulnerable position as you are relevant to [name] for only as long as your knowledge or products are relevant. That is, you personally are not important to [him]. It means that [name] is unlikely to cut you much slack if you make mistakes; they just undermine your relevance."
        ],
        "3": [
          "As you have had a few meetings now, there is a likelihood that you are locked into a Technical relationship, where you are valued solely for your technical expertise. Whilst that might appear to be a strength, it will last only as long as your knowledge or product/service has the edge.",
          "If you or your product/service lose that edge against competitors you will come under intense pricing  pressure as your personal competitiveness will not bridge the gap.",
          "Your focus must be to get on a much stronger personal footing with [name] so that [he] comes to trust you and care about you."
        ]
      }
    }
  ],

  A: [
    {
      scoreRange: "60-69",
      meetings: {
        "1": [
          "Well done! It is early in your relationship with [name], but the signs are good. Your interaction with [him] is close to that of a partner and there are probably a few small things you can do to get there and make the relationship less ad-hoc.",
          "Try driving the relationship a bit more yourself and ask about longer term goals [name] may have professionally (in a broad sense, not just related to [his] current job) and particularly personally. Have more personal conversations."
        ],
        "2": [
          "Well done! It is early in your relationship with [name], but the signs are good. Your interaction with [him] is close to that of a partner and there are probably a few small things you can do to get there and make the relationship less ad-hoc.",
          "Try driving the relationship a bit more yourself and ask about longer term goals [name] may have professionally (in a broad sense, not just related to [his] current job) and particularly personally. Have more personal conversations."
        ],
        "3": [
          "Well done! Based on the interaction in this meeting, your relationship with [name] is getting close to being a partnership; there are probably a few small things you can do to get there and make the relationship less Ad-hoc.",
          "Try driving the relationship a bit more yourself and ask about longer term goals [name] may have professionally (in a broad sense, not just related to [his] current job) and particularly personally. Have more personal conversations."
        ]
      }
    },
    {
      scoreRange: "50-59",
      meetings: {
        "1": [
          "It is early days, but the interaction in this meeting indicates you could be creating an Ad hoc relationship with [name]. That is not surprising if a specific issue or challenge is the prompt for the meetings. However, you do not want to get locked into a reactive dynamic. You need to shift your focus from the issue to the relationship.",
          "[Name] probably sees you as a being helpful, but in a narrow context. For example, [name] probably recognizes you provide a great product and/or service that compares well with other offerings.",
          "You are vulnerable as you are not personally differentiated from other people that [name] interacts with. For example, competitors may be trying to build a better more broad relationship."
        ],
        "2": [
          "It is early days, but the interaction in this meeting indicates you could be creating an Ad hoc relationship with [name]. That is not surprising if a specific issue or challenge is the prompt for the meetings. However, you do not want to get locked into a reactive dynamic. You need to shift your focus from the issue to the relationship.",
          "[Name] probably sees you as a being helpful, but in a narrow context. For example, [name] probably recognizes you provide a great product and/or service that compares well with other offerings.",
          "You are vulnerable as you are not personally differentiated from other people that [name] interacts with. For example, competitors may be trying to build a better more broad relationship."
        ],
        "3": [
          "Your relationship with [name] is likely to be a reactive one where [he] values your ability to address challenges within the specific confines of your expertise. You are seen a source of information rather than as an influence.",
          "You run the risk that someone else takes a more proactive approach with [name] and becomes more influential.",
          "Your focus must be to get on a much stronger personal footing with [name] so that [he] comes to trust you and care about you."
        ]
      }
    },
    {
      scoreRange: "50",
      meetings: {
        "1": [
          "There is a good chance that [name] sees you as someone to go to when [he] has a current or imminent challenge within your apparent field of expertise.  The question is whether there are others e.g. competitors, that can respond as well or even better than you do and who may provide additional value as well.",
          "You are in a vulnerable position as you are relevant to [name] for only as long as your knowledge or products are relevant. That is, you personally are not important to [him]. It means that [name] is unlikely to cut you much slack if you make mistakes; they just undermine your relevance."
        ],
        "2": [
          "There is a good chance that [name] sees you as someone to go to when [he] has a current or imminent challenge within your apparent field of expertise.  The question is whether there are others e.g. competitors, that can respond as well or even better than you do and who may provide additional value as well.",
          "You are in a vulnerable position as you are relevant to [name] for only as long as your knowledge or products are relevant. That is, you personally are not important to [him]. It means that [name] is unlikely to cut you much slack if you make mistakes; they just undermine your relevance."
        ],
        "3": [
          "You have now had a few meetings with [name] and it seems [he] probably sees you as someone to go to when [he] has a current or imminent challenge within your apparent field of expertise, but not as more than that.  The threat for you is that others e.g. competitors, may respond as well or even better than you do and provide additional value as well. You need to change how you are perceived by [name] focusing on your relationship with [him] and not just responding to [his] immediate requirements.",
          "If you or your product/service lose their edge against competitors you will come under intense pricing pressure as your personal competitiveness will not bridge the gap.",
          "Your focus must be to get on a much stronger personal footing with [name] so that [he] comes to trust you and care about you."
        ]
      }
    }
  ],

  S: [
    {
      scoreRange: "60-69",
      meetings: {
        "1": [
          "It is early in your relationship with [name], but the interaction seems to indicate you have established a rapport that will help you to quickly form a partnership. However, one caution...with social relationships you can easily become stuck at that level if you are concerned that talking business might compromise a friendship.",
          "Try spending more time talking about business issues. You should be able to leverage your friendship to get [name] to open up about how [he] feels, which should get you beyond the standard corporate responses and enable you to gain more critical personal insights.",
          "Your motivation in getting to know [name] better personally should be genuine concern for [name]'s well-being; simply giving the appearance of concern to get [name] to open up, is cynical and anything but trustworthy behavior."
        ],
        "2": [
          "It is early in your relationship with [name], but the interaction seems to indicate you have established a rapport that will help you get  to partner quickly. However, with social relationships, you can easily become stuck at that level if you are concerned that talking business might compromise a friendship.",
          "Try spending more time talking about business issues. You should be able to leverage your friendship to get [name] to open up about how [he] feels, which should get you beyond the standard corporate responses and enable you to gain more critical personal insights.",
          "Your motivation in getting to know [name] better personally should be genuine concern for [name]'s well-being; simply giving the appearance of concern to get [name] to open up, is cynical and anything but trustworthy behavior."
        ],
        "3": [
          "Your relationship with [name] is fairly close to being a partnership.  However, with social relationships it is quite easy to get stuck at this level as you may be concerned about compromising your friendship in getting on to a more business-like and trusted footing.",
          "Try spending more time talking about business issues. You should be able to leverage your friendship with [name] to get [him] to open up about how [he] feels, which should get you beyond the standard corporate responses and enable you to gain more critical personal insights.",
          "Your motivation in getting to know [name] better personally should be genuine concern for [name]'s well-being; simply giving the appearance of concern to get [name] to open up, is cynical and anything but trustworthy behavior."
        ]
      }
    },
    {
      scoreRange: "50-59",
      meetings: {
        "1": [
          "It is early days, but the interaction in this meeting indicates you could be creating a Social relationship with [name]. That suggests you are developing a rapport, which is good, however a characteristic of Social relationships is that it is quite easy to get stuck at that level as you may be concerned about compromising the budding friendship in getting on to a more business-like footing.",
          "Try spending more time talking about business issues. You should be able to leverage your friendship with [name] to get [him] to open up about how [he] <i>feels</i>, which should get you beyond the standard corporate responses and enable you to gain more critical personal insights.",
          "In getting personal with [name], your motivation should be genuine concern for [his] well-being; simply giving the appearance of concern to get [name] to open up is cynical and anything but trustworthy behavior."
        ],
        "2": [
          "It is early days, but the interaction in this meeting indicates you could be creating a Social relationship with [name]. That suggests you are developing a rapport, which is good, however a characteristic of social relationships is that it is quite easy to get stuck at that level as you may be concerned about compromising the budding friendship in getting on to a more business-like footing.",
          "Try spending more time talking about business issues. You should be able to leverage your friendship with [name] to get [him] to open up about how [he] <i>feels</i>, which should get you beyond the standard corporate responses and enable you to gain more critical personal insights.",
          "In getting personal with [name], your motivation should be genuine concern for [his] well-being; simply giving the appearance of concern to get [name] to open up is cynical and anything but trustworthy behavior."
        ],
        "3": [
          "The emphasis of your relationship is fairly strongly entrenched in social aspects.  You should think about holding meetings in more formal locations and also to talk much more about business.",
          "You should be able to leverage your friendship with [name] to get [him] to open up about how [he] <i>feels</i> about issues, which should get you beyond the standard corporate responses and enable you to gain more critical personal insights.",
          "In getting personal with [name], your motivation should be genuine concern for [his] well-being; simply giving the appearance of concern to get [name] to open up is cynical and anything but trustworthy behavior."
        ]
      }
    },
    {
      scoreRange: "50",
      meetings: {
        "1": [
          "This interaction indicates that your relationship with [name] is based almost solely on socialising. [He] may value your friendship, however [name] no doubt has other friends and also business associates that may well provide [him] with greater (business) value.",
          "Depending on the style of person you are and the exact nature of your relationship with [name] e.g. [he] may be a close personal friend, it may seem difficult to shift from friendship to a more business-focused relationship.   You don't have to compromise your friendship, but you may think that a risk and so it will impact your interaction with [him]."
        ],
        "2": [
          "This interaction indicates that your relationship with [name] is based almost solely on socialising. [He] may value your friendship, however [name] no doubt has other friends and also business associates that may well provide [him] with greater (business) value.",
          "Depending on the style of person you are and the exact nature of your relationship with [name] e.g. [he] may be a close personal friend, it may seem difficult to shift from friendship to a more business-focused relationship.   You don't have to compromise your friendship, but you may think that a risk and so it will impact your interaction with [him]."
        ],
        "3": [
          "This interaction indicates that your relationship with [name] is based almost solely on socialising. [He] may value your friendship, however [name] no doubt has other friends and also business associates that may well provide [him] with greater (business) value.",
          "If you are having difficulty in getting around to business issues with [name], it can help to involve a colleague in your meetings who will lead the discussion into more business-related territory. You can then pursue this topics in subsequent meetings to shift the dynamic from what it has traditionally been."
        ]
      }
    }
  ]
}
  
   
	
	
  },
  questions: [
    {
      id: '1',
      questionText: '1. Who did most of the talking?',
      leftLabel: 'You',
      rightLabel: '[Name]',
      weightings: {
        left: { weightings: ['T', 'A'] },
        right: { weightings: ['S', 'P'] }
      },
      helpText: 'Score 1 (Far Left) if you find yourself doing most of the talking during the initial interaction.\nScore 2 (Lean Left) if you talk slightly more than [Name].\nScore 3 (Balanced) if the conversation is equal.\nScore 4 (Lean Right) if [Name] talks slightly more.\nScore 5 (Far Right) if [Name] dominates the conversation.'
    },
    {
      id: '2',
      questionText: '2. Was the conversation mostly about?',
      leftLabel: 'Your organization / offering',
      rightLabel: 'Personal issues',
      weightings: {
        left: { weightings: ['T', 'A'] },
        right: { weightings: ['S'] }
      },
      helpText: 'Score 1 (Far Left) if the conversation centers almost entirely on your company or products.\nScore 2 (Lean Left) if it is mostly about your organization but touches on other things.\nScore 3 (Balanced) if it is a mix of both.\nScore 4 (Lean Right) if it is mostly about personal matters.\nScore 5 (Far Right) if it is almost entirely about personal issues.'
    },
    {
      id: '3',
      questionText: '3. Which of the following was discussed most?',
      leftLabel: 'Personal issues',
      rightLabel: 'Business issues',
      weightings: {
        left: { weightings: ['S'] },
        right: { weightings: ['A', 'T', 'P'] }
      },
      helpText: 'Score 1 (Far Left) if the discussion is heavily focused on personal or social topics.\nScore 2 (Lean Left) if it leans towards social topics.\nScore 3 (Balanced) if it is an equal mix.\nScore 4 (Lean Right) if it leans towards business topics.\nScore 5 (Far Right) if the discussion is heavily focused on business.'
    },
    {
      id: '4',
      questionText: '4. Were any business discussions mostly about',
      leftLabel: 'Your organization / offering',
      rightLabel: "[Name]'s organization / challenges / needs",
      weightings: {
        left: { weightings: ['T', 'A'] },
        right: { weightings: ['P'] }
      },
      helpText: 'Score 1 (Far Left) if business discussions focus on your organization/products.\nScore 2 (Lean Left) if they lean towards your organization.\nScore 3 (Balanced) if they are balanced.\nScore 4 (Lean Right) if they focus more on [Name]\'s organization.\nScore 5 (Far Right) if they are almost exclusively about [Name]\'s organization.'
    },
    {
      id: '5',
      questionText: "5. Were any discussions about [Name]'s business mostly regarding",
      leftLabel: 'Issues you might be able to solve',
      rightLabel: 'Issues you may not be able to solve',
      weightings: {
        left: { weightings: ['T', 'A'] },
        right: { weightings: ['P'] }
      },
      helpText: 'Score 1 (Far Left) if discussions focus on problems your specific product/service solves.\nScore 2 (Lean Left) if they lean that way.\nScore 3 (Balanced) if equal.\nScore 4 (Lean Right) if they touch on broader management issues.\nScore 5 (Far Right) if they focus on high-level general management issues.'
    },
    {
      id: '6',
      questionText: '6. Was the setting',
      leftLabel: 'Informal',
      rightLabel: 'Formal',
      weightings: {
        left: { weightings: ['S'] },
        right: { weightings: ['T', 'A', 'P'] }
      },
      helpText: 'Score 1 (Far Left) for very casual/informal settings (e.g., coffee shop, lunch).\nScore 2 (Lean Left) for somewhat informal.\nScore 3 (Balanced) for neutral settings.\nScore 4 (Lean Right) for somewhat formal (e.g., meeting room).\nScore 5 (Far Right) for very formal business settings.'
    },
    {
      id: '7',
      questionText: '7. Was the meeting convened',
      leftLabel: "When [Name]'s need was imminent",
      rightLabel: 'When [Name] was not aware of needing your help',
      weightings: {
        left: { weightings: ['A', 'T'] },
        right: { weightings: ['P'] }
      },
      helpText: 'Score 1 (Far Left) if the meeting was called for an urgent, immediate problem.\nScore 2 (Lean Left) if mostly urgent.\nScore 3 (Balanced) if mixed.\nScore 4 (Lean Right) if mostly proactive/strategic planning.\nScore 5 (Far Right) if entirely proactive or strategic.'
    },
    {
      id: '8',
      questionText: '8. What was your main criteria for success for the meeting',
      leftLabel: 'Acceptance of your ideas / suggestions / offering',
      rightLabel: 'Being of value to [Name] in the meeting',
      weightings: {
        left: { weightings: ['T', 'A'] },
        right: { weightings: ['P', 'S'] }
      },
      helpText: 'Score 1 (Far Left) if success means them accepting your pitch/ideas.\nScore 2 (Lean Left) if mostly acceptance.\nScore 3 (Balanced) if mixed.\nScore 4 (Lean Right) if success is defined by value created.\nScore 5 (Far Right) if success is purely about value generation.'
    },
    {
      id: '9',
      questionText: '9. Who called the meeting?',
      leftLabel: 'You',
      rightLabel: '[Name]',
      isBinary: true,
      weightings: {
        left: { weightings: ['T'] },
        right: { weightings: ['A'] }
      },
      helpText: 'Select "You" if you requested the meeting.\nSelect "[Name]" if the client/other party requested it.'
    }
  ],
  branches: {
    a: [
      {
        id: 'a10',
        questionText: '10. Did you call about',
        leftLabel: 'Something to do with business',
        rightLabel: 'Something social',
        weightings: {
          left: { weightings: ['T'] },
          right: { weightings: ['S'] }
        },
        helpText: 'Score 1 (Far Left) if you called strictly for business.\nScore 2 (Lean Left) if mostly business.\nScore 3 (Balanced) if mixed.\nScore 4 (Lean Right) if mostly social.\nScore 5 (Far Right) if purely social.'
      },
      {
        id: 'a11',
        questionText: '11. To what extent were business discussions about',
        leftLabel: "A way you might be able to help [Name]'s business",
        rightLabel: "A way you might be able to help [Name] personally",
        weightings: {
          left: { weightings: ['T'] },
          right: { weightings: ['P'] }
        },
        helpText: "Score 1 (Far Left) if discussions were purely about helping [Name]'s business.\nScore 2 (Lean Left) if mostly about the business.\nScore 3 (Balanced) if mixed.\nScore 4 (Lean Right) if mostly about helping [Name] personally.\nScore 5 (Far Right) if purely about helping [Name] personally."
      }
    ],
    b: [
      {
        id: 'b10',
        questionText: '10. Did [Name] call about',
        leftLabel: 'Something to do with business',
        rightLabel: 'Something social',
        weightings: {
          left: { weightings: ['A'] },
          right: { weightings: ['S', 'P'] }
        },
        helpText: 'Score 1 (Far Left) if they called strictly for business.\nScore 2 (Lean Left) if mostly business.\nScore 3 (Balanced) if mixed.\nScore 4 (Lean Right) if mostly social.\nScore 5 (Far Right) if purely social.'
      },
      {
        id: 'b11',
        questionText: '11. To what extent were business discussions about',
        leftLabel: "A way you might be able to help [Name]'s business",
        rightLabel: "A way you might be able to help [Name] personally",
        weightings: {
          left: { weightings: ['A'] },
          right: { weightings: ['T', 'P'] }
        },
        helpText: "Score 1 (Far Left) if discussions were purely about helping [Name]'s business.\nScore 2 (Lean Left) if mostly about the business.\nScore 3 (Balanced) if mixed.\nScore 4 (Lean Right) if mostly about helping [Name] personally.\nScore 5 (Far Right) if purely about helping [Name] personally."
      }
    ]
  },
  qaDetail: [
     {
      qid: "1",
      type: "T",
      values: [-2,-1],
      text: "Try getting [Name] to talk first and if possible about the longer term; for example business strategy. Ask open-ended questions about where [Name] would like to be in the future and what [he] sees as [his] challenges in getting there."
    },
    {
      qid: "1",
      type: "P",
      values: [-2,-1],
      text: "In your next meetings, see if you can get [Name] talking more."
    },
	{
      qid: "1",
      type: "A",
      values: [-2,-1],
      text: "Try getting [name] to talk first by asking [him] to describe the underlying issues that [he] believes are driving [his] current challenge(s). Ask open-ended questions about where [he] would like to be in the future and how [he] sees himself getting there. Expand the discussion beyond current topic(s) by asking [name] about other challenges...in the broadest sense, not just the topics that [he] thinks that you would have an interest in"
    },
    {
      qid: "2",
      type: "P",
      values: [-2,-1],
      text: "Take the opportunity to explore how [Name]'s professional role is affecting [him] personally."
    },
    {
      qid: "3",
      type: "S",
      values: [-2,-1],
      text: "Make a gradual shift from a personal to a business discussion by framing some questions to [Name] in terms of how well work is going for [him]."
    },
	{
	qid: "3",
      type: "T",
      values: [1, 2],
      text: "Identify some of [name]'s more personal goals e.g. lifestyle, family and so on. Resist talking about your company, products or services. By displaying interest in [name] as a person, [he] will see that you care about [him]; [he] will become more confident about you and ultimately come to trust you and be more candid."
    },
	{
	qid: "3",
      type: "A",
      values: [1, 2],
      text: "Try to move off business topics and get to know [name] personally a little better. For example, ask about [his] personal goals and ambitions."
    },
	{
      qid: "4",
      type: "T",
      values: [-2, -1],
      text: "Resist talking about your offering or company. Ask [name] broader questions to gain an understanding (for example) of [his] longer term challenges and what [he] sees as the implications of those for [him] and [his] business."
    },
	{
      qid: "4",
      type: "A",
      values: [-2, -1],
      text: "Resist talking about your company, products or services (even if you are asked) and instead get to understand what it means to [name] and [his] organization to resolve [his] current challenges and in particular what the longer term benefits will be."
    },
	{  
     qid: "4",
      type: "P",
      values: [-2, -1],
      text: "In the next meeting see if you can have the discussion focus solely on [name] and/or [his] organization with no reference to your own organization or products/services."
    },
	{
      qid: "5",
      type: "T",
      values: [-2, -1],
      text: "Consciously ask questions to identify if there are any challenges [Name] faces which are outside your area of expertise. Even though you may not be able to address these, by becoming engaged you may be able to identify someone in your circle that can help [Name]."
    },
	{
      qid: "5",
      type: "A",
      values: [-2, -1],
      text: "Consciously ask questions to identify if there are any additional challenges [name] faces which are outside your area of expertise. Even though you may not be able to address these, by becoming engaged you may be able to identify someone in your circle that can help [name] and in the process demonstrate to [name] that your concern extends beyond your own areas of interest."
    },
	{
      qid: "5",
      type: "P",
      values: [-2, -1],
      text: "Next time you speak to [name] have a more wide-ranging conversation; for example see if you can focus entirely on issues you or your organization may not be able to address."
    },
	{
      qid: "6",
      type: "S",
      values: [-2, -1],
      text: "If meetings are typically in informal locations then suggest that the next one be in [name]'s office, as you would like to get a feel for [his] work environment."
    },
	{
      qid: "6",
      type: "T",
      values: [1, 2],
      text: "If you tend to always meet in formal surroundings, try to suggest a more informal setting for your next meeting (e.g. coffee/lunch)."
    },
	{
      qid: "6",
      type: "A",
      values: [2, 1],
      text: "If [name] tends to call you to arrange a meeting at your office then next time suggest maybe a less formal location such as a coffee shop."
    },
	{
      qid: "7",
      type: "A",
      values: [-2, -1],
      text: "Avoid getting stuck on immediate and short-term issues. Ask about [Name]'s longer term plans so you learn about potential future challenges earlier on."
    },
	{
      qid: "7",
      type: "P",
      values: [-2, -1],
      text: "Have [name] talk about [his] and [his] organization's vision and longer term strategies."
    },
	 {
      qid: "8",
      type: "T",
      values: [-2, -1],
      text: "Resist talking about your offering or company. Ask for broader questions to gain an understanding (for example) of [his] longer term challenges and what [he] sees as the implications of those for [him] and [his] business."
    },
	{
      qid: "8",
      type: "A",
      values: [-2, -1],
      text: "Even if the opportunities arise to do so, resist talking about your offering or your company. Stories you can tell about what you have achieved for other clients are more effective than bland capability statements about what you can do for [name]. Also, look for general insights into business and industry (not to do with your company) that [name] is unlikely to be aware of but that you can pass on to [him]"
    },
	{
      qid: "8",
      type: "P",
      values: [-2, -1],
      text: "Really focus on ensuring [name] gets all the value from your interaction. A good way to check for this is to ask yourself whether [name] would have been prepared to pay you for the time you spent with [him]."
    },
	{
      qid: "9",
      type: "T",
      values: [-2],
      text: "If you are the one that is always calling meetings and you do so frequently, try leaving it a little longer before you call next time to see if [Name] initiates a conversation."
    },
	{
      qid: "9",
      type: "T",
      values: [2],
      text: "If [name] tends to initiate contact then next time get in first and you initiate contact."
    },
	{
      qid: "9",
      type: "S",
      values: [2],
      text: "If [name] typically calls to arrange something social then maybe suggest a second meeting in a more formal location. Alternatively, you could initiate the next meeting and make it for an environment conducive to a business discussion."
    },
	{
      qid: "9",
      type: "A",
      values: [2],
      text: "Next time, try to initiate contact yourself."
    },
	{	
	qid: "9",
      type: "P",
      values: [2],
      text: "If [name] tends to initiate contact then next time get in first and you initiate contact."
    },	
	{	
	qid: "9",
      type: "P",
      values: [-2],
      text: "If you are the one that is typically calling meetings, try leaving it a little longer before you call next time to see if [name] initiates a conversation."
    },	
	{
      qid: "9",
      type: "S",
      values: [-2],
      text: "If you always call the meeting to arrange something social try to resist contacting [name] for a while. See if [he] contacts you and if [he] does, suggest a business setting"
    },
	{
      qid: "a10",
      type: "T",
      values: [-2, -1],
      text: "Although a business need may have driven the need for the meeting, take the opportunity in every interaction with [Name] to build your relationship by having some personal dialog."
    },
	{
      qid: "a10",
      type: "S",
      values: [1, 2],
      text: "Ensure you ask [name] about some work-related or business issues."
    },
	{
      qid: "a11",
      type: "T",
      values: [-2, -1],
      text: "Look to the future and ask [Name] for [his] longer term views on how [he] sees [his] business. The more you understand where [Name] is going, the better able you will be to help [him] get there."
    },
    {
    qid: "b10",
    type: "A",
    values: [-2, -1],
    text: "Balance the conversation and build your relationship by covering some social and personal topics as well."
  },
  {
    qid: "b10",
    type: "T",
    values: [-2, -1],
    text: "Although a business need may have driven the need for the meeting, take the opportunity in every interaction with [name] to build your relationship by having some personal dialog. Perhaps pick up on a thread from a previous meetings e.g. how was that holiday?"
  },
  {
    qid: "b10",
    type: "S",
    values: [1, 2],
    text: "Make sure that you bring business into the discussion, but on [name]'s terms by making it about [his] challenges both now and preferably into the future."
  },
  {
    qid: "b11",
    type: "A",
    values: [-2, -1],
    text: "Look to the future and ask [Name] for [his] longer term views on how [he] sees [his] business. The more you understand where [Name] is going, the better able you will be to help [him] get there. It will also demonstrate that you are not just focused on an immediate return, but that you are concerned about [Name]'s long term success."
  },
  {
      qid: "b11",
      type: "T",
      values: [-2, -1],
      text: "Look to the future and ask [Name] for [his] longer term views on how [he] sees [his] business. The more you understand where [Name] is going, the better able you will be to help [him] get there."
    }
  ]
};